import React from "react";
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const clientvpn = require("../../../assets/icons-pack/5.5 Virtual Private Network/ic_01_clientvpn.svg");
const vpncertified = require("../../../assets/icons-pack/5.5 Virtual Private Network/ic_02_vpncertified.svg");
const selfservice = require("../../../assets/icons-pack/5.5 Virtual Private Network/ic_03_selfservice.svg");

const VPN = () => {
    const heading = `VIRTUAL PRIVATE NETWORK (VPN)`;
    const details = `Connect with DETASAD cloud using an enterprise grade secure Virtual Private Network.`;

    const overview = [
        `Protect your data across the public Internet with virtual private network (VPN) software. DETASAD Managed VPN service gives you a secure, seamless way to access cloud resources from anywhere in the world using any device.`
    ];

    const advantages = [
        [
            `Secure`,
            `IPsec offers the ability to create persistent, secure tunnels across a public network. DETASAD supports connections between networks (“gateway to gateway”) as well as connections between users on untrusted networks and their secure applications ("host to gateway"). Users can quickly provision a site to site VPN via the self-service Control Portal.`,
            selfservice
        ],
        [
            `No Extra Charge`,
            `Each account gets its own isolated client virtual private network at no charge.`,
            vpncertified
        ],
        [
            `Simple Configuration`,
            `You can create an easy-to-use VPN connection by specifying parameters on the console and configuring it with your system.`,
            clientvpn
        ],
        [
            `Immediately Accessible`,
            `Allows you to purchase VPN connections on demand. The connections are immediately accessible upon creation.`,
            clientvpn // temp
        ]
    ];

    const functions = [
        [
            `Flexible and Scalable`,
            [
                `DETASAD’s VPN allows you to extend your local data center into DETASAD’s Cloud, with an in-built ability to meet application and service scaling requirements.`
            ]
        ],
        [
            `Ensured Data Integrity and Security`,
            [
                `DETASAD’s network hardware encrypts data based on IKE and IPsec with carrier-class reliability and ensures VPN connection stability.`
            ]
        ],
        [
            `On-Demand`,
            [
                `We understand that your time is precious, therefore we have designed DETASAD’s VPN to be configured and accessible in no time.`
            ]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-network"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default VPN;
